module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_lovecraft.26f11e85.jpg";